import { createContext } from 'react';

const EventsContext = createContext();

export default EventsContext;